import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Products from './pages/Products/Products';
import Services from './pages/Services/Services';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { getReactPlugin } from './appInsights';

function App() {
  const reactPlugin = getReactPlugin();

  const content = (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/services" element={<Services />} />
      </Routes>
    </BrowserRouter>
  );

  // Only wrap with AppInsightsContext if plugin is initialized
  if (reactPlugin) {
    return <AppInsightsContext.Provider value={reactPlugin}>{content}</AppInsightsContext.Provider>;
  }

  return content;
}

export default App;
